import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyRouteComponent } from 'app/empty-route/empty-route.component';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: EmptyRouteComponent,
            }
        ]),
    ],
    declarations: [
        EmptyRouteComponent
    ]
})
export class EmptyRouteModule {
}
